module.exports = __webpack_public_path__ + "static/media/halfRussia.bd599139.svg";